import { useWizard } from "react-use-wizard";
import {
  TKeyOfDataWizardTradeIn,
  TNumberKeysOfIFillDataWizardTradeIn,
} from "..";
import useGeoPolygonByBuilding from "../../../../../../api/hooks/use-geo-polygon-by-building";
import tradeInSteps from "./tradeInSteps";
import ChooseAreaStep from "../../../../../shared/wizard/steps/chooseAreaStep";

interface ITradeInStep_5 {
  isNextStepDisabled: boolean;
  onChange: (data: number[], key: TNumberKeysOfIFillDataWizardTradeIn) => void;
  data: number[] | null;
  buildingId: number | null;
  onReset: (key: TKeyOfDataWizardTradeIn[]) => void;
}

const TradeInStep_5 = ({
  isNextStepDisabled,
  buildingId,
  data,
  onChange,
  onReset,
}: ITradeInStep_5) => {
  const { goToStep } = useWizard();

  const { trigger } = useGeoPolygonByBuilding();

  const handlePrevStep = () => {
    goToStep(tradeInSteps.step_4.step);
    onReset(["rejectedLocationIds"]);
  };

  const handleNextStep = async () => {
    // по текущему билдингу с оценки получаем полигон
    if (buildingId) {
      const data = await trigger(buildingId);
      onChange([data.id], "rejectedLocationIds");
    }
    goToStep(tradeInSteps.step_6.step);
  };

  return (
    <div>
      <ChooseAreaStep
        counterPage={{
          current: tradeInSteps.step_5.page,
          max: tradeInSteps.step_5.maxPage,
        }}
        isNextStepDisabled={isNextStepDisabled}
        handleNextStep={handleNextStep}
        handlePrevStep={handlePrevStep}
        data={data}
        onChange={onChange}
      />
    </div>
  );
};

export default TradeInStep_5;
